export const ContextSourceTypes = {
  Document: 'Document',
  SourceCode: 'SourceCode',
  Image: 'Image',
  Archive: 'Archive',
} as const

export const ContextSourceKinds = {
  File: 'File',
  Repository: 'Repository',
  Wiki: 'Wiki',
} as const

export const MAX_INLINE_EDITABLE_CONTENT_SIZE_BYTES = 10 * 1024 * 1024
